// extracted by mini-css-extract-plugin
export default {"info":"Flow_info__WDGro","title":"Flow_title__WDryw","icon":"Flow_icon__awUZs","defaultInfo":"Flow_defaultInfo__vh1D-","chartContainerDiv":"Flow_chartContainerDiv__l2-1x"};